import { timestampCodec } from "../../validation/codecs";
import { mixed, required, t } from "../../validation/validator";
import { CallResponseSchema } from "../common/callResponseSchema";

export const ReplayRecordSchema = t.type({
  user_id: t.number,
  cognitive_result_id: t.number,
  created_at: timestampCodec,
  updated_at: t.union([timestampCodec, t.null]),
  last_played_at: t.union([timestampCodec, t.null]),
  storage_bucket: t.union([t.string, t.null]),
  storage_file_path: t.union([t.string, t.null]),
  storage_file_size: t.union([t.number, t.null]),
  archived_at: t.union([timestampCodec, t.null]),
  restored_at: t.union([timestampCodec, t.null]),
});

export const RequestReplaySchema = t.type({
  cognitive_result_id: t.number,
  user_id: t.string,
});

export const ReplayResponseSchema = mixed([
  required({
    data: ReplayRecordSchema,
    download_url: t.string,
  }),
  CallResponseSchema,
]);

export type ReplayRecord = t.TypeOf<typeof ReplayRecordSchema>;
export type RequestReplayRequest = t.TypeOf<typeof RequestReplaySchema>;
export type ReplayResponse = t.TypeOf<typeof ReplayResponseSchema>;

export const ReplayApis = {
  Replays: {
    RequestReplay: {
      Name: "replays-requestReplay",
      Request: RequestReplaySchema,
      Response: ReplayResponseSchema,
    },
  },
};
